export const CopilotPrioritizeOnboardedCalloutTitle = "xsXGSd";
export const CopilotPrioritizeOnboardedCalloutDesc = "eZ$Nre";
export const CopilotPrioritizeOnboardedCalloutGotItButtonText = "PKlEnc";
export default {CopilotPrioritizeOnboardedCalloutTitle,CopilotPrioritizeOnboardedCalloutDesc,CopilotPrioritizeOnboardedCalloutGotItButtonText};